import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { deleteApi, getApi } from "../../utils/api";
import { API_EMPLOYEE_DEPENDENT } from "../../config/Endpoints";
import { showSuccess, showError } from "../../v2/utils/toast.ts";
import AddEducation from "./AddEducation";
import AddDependent from "./AddDependent";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import SortableTable from "../../components/SortableTable";
import { displayFormatDate } from "../../utils/helpers";

const Dependents = ({ dependentData }) => {
  const [dependentList, setDependentList] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [selectedDependent, setSelectedDependent] = useState({});
  const [selectedDependentId, setSelectedDependentId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { key: "name", label: "Name" },
    { key: "gender", label: "Gender" },
    {
      key: "dob",
      label: "DOB",
      compare: (a, b) => new Date(a.dob) - new Date(b.dob),
      render: (item) => displayFormatDate(item.dob),
    },
    { key: "relationship", label: "Relation" },
    { key: "number", label: "Mobile Number" },
    {
      key: "actions",
      label: "Actions",
      render: (item) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <a href="javascript:void(0)" onClick={() => handleView(item)}>
            Edit
          </a>
          <a
            href="javascript:void(0)"
            onClick={() => handleDeleteAlert(item.dependentId)}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdropDependentDelete"
            className="text-danger"
          >
            Delete
          </a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setDependentList(dependentData);
  }, [dependentData]);

  const handleDelete = () => {
    setIsLoading(true);
    deleteApi(API_EMPLOYEE_DEPENDENT + `/${selectedDependentId}`, accessToken)
      .then((res) => {
        if (res.status === 200) {
          let newArray = dependentList.filter(
            (item) => item.dependentId !== selectedDependentId,
          );
          setDependentList(newArray);
          setIsLoading(false);
          const modalClose = document.getElementsByClassName(
            "cancel-modal-dependent-delete",
          )[0];
          modalClose.click();
          showSuccess(res.data.message);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };
  const handleDeleteAlert = (id) => {
    setSelectedDependentId(id);
  };

  const handleView = (item) => {
    setSelectedDependent(item);
  };

  return (
    <>
      {dependentList?.length === 0 ? (
        <div className="fs-4 text-secondary text-center">
          No records available
        </div>
      ) : (
        <SortableTable
          className="resume custom"
          data={dependentList}
          columns={columns}
        />
      )}
      <button
        className="theme-button  p-2 mt-3 add-dependent"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropDependent"
      >
        + Add Dependents
      </button>

      <div
        className="modal fade"
        id="staticBackdropDependent"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <AddDependent
              setDependentList={setDependentList}
              selectedDependent={selectedDependent}
              setSelectedDependent={setSelectedDependent}
            />
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="staticBackdropDependentDelete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="text-center">
                Are you sure you want to delete this dependent record ?
              </h5>
            </div>
            <div className="justify-content-center modal-footer">
              <button
                type="button"
                className={
                  isLoading ? "theme-button disabled " : "theme-button "
                }
                onClick={handleDelete}
              >
                {isLoading ? (
                  <ThreeDots
                    height="20"
                    width="53"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  "Yes"
                )}
              </button>
              <button
                type="button"
                className="theme-button bg-grey mx-3 w-35 cancel-modal-dependent-delete"
                data-bs-dismiss="modal"
                onClick={() => setSelectedDependentId("")}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dependents;
